module.exports = "/images/quotes.svg";